import { instancesStore } from 'state'
import history from 'services/history'
import { logout, updatePassword } from 'pages/Login/actions'
import { resetSidebarStore } from './actions'

export default (t) => [
  {
    title: t('Settings:Password'),
    onClick: () => updatePassword(),
    kind: 'secondary'
  },
  {
    title: t('Settings:Logout'),
    isDelete: true,
    onClick: async () => {
      await logout()
      resetSidebarStore()
      instancesStore.set([])
      return history.replace('/')
    }
  }
]
